import * as React from 'react';

import { useQuery } from '@apollo/client';

import { get as userGet } from 'js/lib/user';

import ConsumerMyPageHeaderContext from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import ConsumerMyPageHeaderQuery from 'bundles/composable-page-header-consumer/queries/ConsumerMyPageHeaderQuery.graphql';
import type {
  ConsumerMyPageHeaderQuery as ConsumerMyPageHeaderQueryType,
  ConsumerMyPageHeaderQueryVariables,
} from 'bundles/composable-page-header-consumer/queries/__generated__/ConsumerMyPageHeaderQuery';

const ConsumerPageHeaderBffProvider = ({ children }: { children: React.ReactNode }) => {
  const isLoggedIn = !!userGet()?.id;

  const { data, error } = useQuery<ConsumerMyPageHeaderQueryType, ConsumerMyPageHeaderQueryVariables>(
    ConsumerMyPageHeaderQuery,
    {
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
      // All fields in this query are logged in, and are unused when logged out.
      // Don't need to fetch data we're not using!
      skip: !isLoggedIn,
    }
  );

  return (
    <ConsumerMyPageHeaderContext.Provider
      value={{
        myPageHeader: data?.PageHeader?.queryMyPageHeader,
        error,
      }}
    >
      {children}
    </ConsumerMyPageHeaderContext.Provider>
  );
};

export default ConsumerPageHeaderBffProvider;
